import Vue from 'vue';
import Router from 'vue-router';
import Meta from 'vue-meta';
import store from '@/store';
// import VueRouterMultiguard from 'vue-router-multiguard';

Vue.use(Router);

const router = new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	linkActiveClass: 'active',
	routes: [{
			path: '*',
			redirect: {
				path: '/404'
			}
		},
		{
			path: '/',
			redirect: {
				path: '/login'
			}
		},
		{
			path: '/login',
			name: 'Login',
			component: () =>
				import( /* webpackChunkName: "routes" */
					`@/views/Login.vue`),
			meta: {
				requiresHome: true
			}
		},
		{
			path: '/dashboard',
			name: 'Dashboard',
			meta: {
				requiresAuth: true
			},
			component: () => import(`@/views/Dashboard`)
		},
		{
			path: '/pelamar',
			// view: 'Pelamar'
			name: 'Pelamar',
			component: () => import(`@/views/Pelamar`),
			meta: {
				requiresAuth: true
			}
		},
		{
			path: '/detail/:id',
			// view: 'Detail'
			name: 'Detail',
			component: () => import(`@/views/Detail`),
			meta: {
				requiresAuth: true
			}
		},
		{
			path: '/hasil-test',
			name: 'Hasil Test',
			component: () => import(`@/views/HasilTest`),
			meta: {
				requiresAuth: true
			}
		},
		{
			path: '/403',
			name: '403',
			// view: 'Deny',
			component: () => import(`@/views/Deny`),
			meta: {
				requiresHome: true
			}
		},
		{
			path: '/404',
			name: '404',
			component: () => import(`@/views/NotFound`),
			meta: {
				requiresHome: true
			}
		},
		{
			path: '/ubah-password',
			name: 'Ubah Password',
			component: () => import(`@/views/UbahPassword`),
			meta: {
				requiresAuth: true
			}
		},
		{
			path: '/ubah-akses-tes',
			name: 'Ubah Token Akses',
			component: () => import(`@/views/UbahAkses`),
			meta: {
				requiresAuth: true
			}
		}
	],

	scrollBehavior(to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition;
		}
		if (to.hash) {
			return {
				selector: to.hash
			};
		}
		return {
			x: 0,
			y: 0
		};
	}
});

router.beforeEach((to, from, next) => {
	if (to.matched.some((record) => record.meta.requiresAuth)) {
		if (!store.getters.isAuthenticated) {
			next('/login');
		} else {
			next();
		}
	} else if (to.matched.some((record) => record.meta.requiresHome)) {
		if (store.getters.isAuthenticated) {
			next('/dashboard');
		} else {
			next();
		}
	} else {
		next();
	}
});

export default router;